import React, { useState, useEffect } from 'react';
import Confetti from 'react-confetti';

const ResultPage = ({ results, onRestartQuiz }) => {
  // États pour les animations
  const [windowSize, setWindowSize] = useState({ width: window.innerWidth, height: window.innerHeight });
  const [showConfetti, setShowConfetti] = useState(true);
  const [animateIn, setAnimateIn] = useState(false);

  // Effet pour gérer la taille de la fenêtre (pour les confettis)
  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Effet pour déclencher l'animation d'entrée et arrêter les confettis après un certain temps
  useEffect(() => {
    // Déclencher l'animation d'entrée après un court délai
    const animationTimer = setTimeout(() => {
      setAnimateIn(true);
    }, 100);

    // Arrêter les confettis après 15 secondes
    const confettiTimer = setTimeout(() => {
      setShowConfetti(false);
    }, 15000);

    return () => {
      clearTimeout(animationTimer);
      clearTimeout(confettiTimer);
    };
  }, []);

  // Définitions des profils
  const profiles = {
    'Le Papa Cool': {
      description: "Tu es un papa détendu, complice, qui laisse ses enfants grandir à leur rythme. Tu encourages l’autonomie, la créativité, et crois aux vertus de la liberté.",
      image: '/images/papa-cool.jpg'
    },
    'Le Papa Mature': {
      description: "Tu es prévoyant, protecteur, toujours là pour guider et sécuriser. Tu fais preuve de sagesse et d’équilibre dans ton rôle de père.",
      image: '/images/papa-mature.jpg'
    },
    'Le Papa Câlin': {
      description: "Tu es un papa doux, tendre, très affectueux. Pour toi, l’amour et la présence comptent plus que tout. Tu es le pilier émotionnel de la famille.",
      image: '/images/papa-calin.jpg'
    },
    'Le Papa Vieille École': {
      description: "Tu es exigeant, structuré, convaincu que l’effort forge le caractère. Tu prépares tes enfants à affronter la vie avec discipline et ambition.",
      image: '/images/papa-vieille-ecole.jpg'
    }
  };

  const profile = profiles[results.mamaType];

  return (
    <div>
      {/* Composant de confettis en dehors du conteneur pour couvrir tout l'écran */}
      {showConfetti && (
        <Confetti
          width={windowSize.width}
          height={windowSize.height}
          numberOfPieces={200}
          recycle={false}
          colors={['#FF7900', '#F16E00', '#FFB800', '#FFC799', '#FFE0CC']}
          style={{ position: 'fixed', top: 0, left: 0, zIndex: 1000 }}
        />
      )}
      
      <h1 className="title-main">Spécial Fête des pères</h1>
      <h3 className="title-sub">Quel type de papa es-tu ?</h3>
      <br />
      <div className="container">
      
      <div className={`header ${animateIn ? 'animate-in' : ''}`}>
        <h1>Ton résultat</h1>
      </div>
      <div className={`result-container ${animateIn ? 'animate-in' : ''}`}>
        <h2 className="result-title">{results.mamaType}</h2>
        <p className="result-description">{profile.description}</p>
        <p className="result-score">Score total : {results.totalScore} points</p>
        
        {/* Image placeholder - à remplacer par des images réelles */}
        <div className="result-image-container">
          <img 
            src={profile.image} 
            alt={results.mamaType} 
            className="result-image"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = '/images/placeholder.png'; // Image de fallback
            }}
          />
        </div>
        
        {/* Logo Orange Money */}
        <div className="logo-container">
          <img 
            src="/images/bg/om-logo.png" 
            alt="Orange Money" 
            className="logo"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = '/images/logo-placeholder.png'; // Logo de fallback
            }}
          />
        </div>
      </div>
      <div className="share-container">
        <p>Prends une capture, partage en commentaire du post Facebook et tente de gagner un super lot !</p>
      </div>
      <button className="btn" onClick={onRestartQuiz}>Refaire le test</button>
      </div>
    </div>
  );
};

export default ResultPage;
